import { useEffect, useState, useCallback } from 'react'
import { useSelector } from 'react-redux';
import { apiurl } from '../../utils/constants';

export const loadSMData = async (DocEntry, mail, sapDB) => {
	const response = await fetch(apiurl + 'sm/inventoryGenExit/bySolpedEntry', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			docEntry: DocEntry,
			user: mail,
			sapDB
		})
	});

	if (!response.ok) {
		throw new Error('Error al cargar datos de SM');
	}

	return response.json();
};

function CreateSMDialog({ DocEntry, solp, onClose }) {

	const { name, mail, sapDB, iden: userIden } = useSelector((state) => state.user);
	const [requestedItems, setRequestedItems] = useState([]);
	const [solped, setSolped] = useState({});
	const [comment, setComment] = useState('');
	const [ware, setWare] = useState([]);
	const [data, setData] = useState([])
	const [sending, setSending] = useState(false);
	const [ingresado, setIngresado] = useState(() => new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().slice(0, 10));

	const fCurr = (value) => {
		return new Intl.NumberFormat('es-CL', {
			currency: 'CLP',
		}).format(value);
	};

	useEffect(() => {
		const fetchSMData = async () => {
			try {
				const data = await loadSMData(DocEntry, mail, sapDB);
				setRequestedItems((data.requestedItems || []).filter(item => item.itemCode && !/^[a-zA-Z]/.test(item.itemCode)));
				setSolped(data.solped || {});
			} catch (error) {
				console.error('Error en la solicitud:', error);
			}
		};

		fetchSMData();
	}, [DocEntry, mail, sapDB]);

	useEffect(() => {
		const listWare = async () => {
			try {
				// setLoadSAP('Obteniendo...');
				const response = await fetch(apiurl + 'queryAux', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					credentials: 'include',
					body: JSON.stringify({ user: mail, query: `SELECT code FROM inv__ware` }),
				});

				if (response.ok) {
					const data = await response.json();
					setWare([{ code: '' }, ...data]);
				} else {
					console.error('Error listWare');
				}
			} catch (error) {
				console.error('Error:', error);
				return null;
			}
		}

		listWare()
	}, [mail])

	const send = useCallback(async () => {
		const items = data.filter(item => item.quantity > 0);

		if (items.length === 0) {
			alert('No hay artículos.\nAsegúrese de incluir al menos 1 artículo para generar la salida de mercancía.');
			return;
		}
		setSending(true);

		const response = await fetch(apiurl + 'sm/inventoryGenExit', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				docEntry: DocEntry,
				user: mail,
				idUser: userIden,
				sapDB,
				items,
				comm: comment,
				userName: name,
				ingresado,
				solp
			}),
		})

		const body = await response.json();
		if (!response.ok) {
			alert(`Error: ${body.msg}`);
		} else {
			onClose(true)
		}

		setSending(false);
	}, [DocEntry, mail, onClose, data, sapDB, comment, userIden, name, ingresado, solp])

	const onChangeData = useCallback(data => {
		setData(prevData => {
			const code = data.code;
			const existingIndex = prevData.findIndex(item => item.code === code);
			if (existingIndex !== -1) {
				const updatedData = [...prevData];
				updatedData[existingIndex] = { ...updatedData[existingIndex], ...data };
				return updatedData;
			} else {
				return [...prevData, { ...data }];
			}
		})
	}, [])

	return (
		<form>
			<orm-modal>
				<dialog open>
					
					<h2>Creando salida de mercancía</h2>
					<table>
						<thead>
							<tr>
								<td>Solicitud de pedido:</td>
								<td>{solp}</td>
								<td>Ingresado:</td>
								<td><input type="date" value={ingresado} onChange={e => setIngresado(e.target.value)} /></td>
								<td>Ingresante:</td>
								<td>{name}</td>
							</tr>
						</thead>
					</table>

					<h2>Líneas incluidas</h2>
					<div className="scroll">
					<table>
						<thead>
							<tr>
								<td>Código</td>
								<td>Descripción</td>
								<td>Precio</td>
								<td>Cantidad</td>
								<td>Almacén</td>
								<td>Costo</td>
								<td>Activo fijo</td>
							</tr>
						</thead>
						<tbody>
							{requestedItems.map((item, index) => (
								<Row key={`${item.itemCode}-${index}`} item={item} fCurr={fCurr} 
								onChangeData={onChangeData}
									solped={solped} ware={ware} />
							))}
						</tbody>
					</table>
					</div>

					<h2>Comentarios</h2>
					<table>
						<tr>
							<td colspan='5'><textarea style={{ width: '100%' }} value={comment} onChange={e => setComment(e.target.value)}></textarea></td>
						</tr>
					</table>

					<table>
						<tfoot>
							<tr>
								<td></td>
								<td>
									<input type="button" value="Cancelar" onClick={onClose} />
									<input type="button" value={sending ? 'Enviando...' : 'Aceptar'} disabled={solped.solped_completed || sending} onClick={send} />
								</td>
							</tr>
						</tfoot>
					</table>

				</dialog>
			</orm-modal>
		</form>
	);
}

function Row({ item, fCurr, solped, ware, onChangeData }) {
	const [isEditingWare, setIsEditingWare] = useState(false)
	const [isEditingFixe, setIsEditingFixe] = useState(false)
	const [value, setValue] = useState({...item, quantity: item.pendingQuantity, fixe: item.uActivoFijo})

	useEffect(()=>{
		onChangeData({
			code: value.itemCode,
			quantity: value.quantity,
			ware: value.warehouseCode,
			fixe: value.fixe
		})
	}, [value, onChangeData])

	return <tr>
		<td>{value.itemCode}</td>
		<td>{value.itemName}</td>
		<td>{fCurr(value.itemCost ?? 0)} CLP</td>
		<td>
			<input
				style={{ width: '10px', maxWidth: '10px' }}
				type='number'
				value={value.quantity}
				min='0'
				max={item.pendingQuantity}
				disabled={item.deliveredQuantity >= item.requestedQuantity}
				onChange={e => {
					const clamped = Math.min(Math.max(0, Number(e.target.value)), item.pendingQuantity);
					setValue(prev => ({ ...prev, quantity: clamped }));
				}}
			/>
			/{item.requestedQuantity}
		</td>
		<td className={` ellipsis ${true ? 'editing' : (true ? 'editable nofloat' : '')}`}
			onClick={true ? () => setIsEditingWare(true) : null}>
			{isEditingWare
				? (<select onBlur={() => setIsEditingWare(false)}
					onChange={(e) => setValue(prev =>({...prev, warehouseCode: e.target.value}))}
				>
					{ware.map((item) => (
						<option key={item.code} value={item.code} selected={item.code === value.warehouseCode}>
							{item.code}
						</option>
					))}
				</select>)
				: value.warehouseCode
			}
		</td>
		<td>{fCurr((value.itemCost ?? 0) * (value.customQuantity ?? value.pendingQuantity ?? 0))} CLP</td>

		<td className={` ellipsis ${isEditingFixe ? 'editing' : true ? 'editable nofloat' : ''}`}
		onClick={true ? () => setIsEditingFixe(true) : null}
		>
			{
				isEditingFixe
					? (<input type="search" value={value.fixe ?? ''}
					onBlur={() => setIsEditingFixe(false)} 
					onChange={(e) => setValue(prev =>({...prev, fixe: e.target.value}))} 
					/>)
					: (<> {value.fixe} </>)
			}
		</td>
	</tr>

}

export default CreateSMDialog;
